/**
 * schoolAssessmentProcessAdapter — maps `POST school-assessments/process` → `UISchoolAssessmentPreview`.
 */
import { type UISchoolAssessmentPreview } from "../../../ui/types"
import { toUISubject, type ApiSchoolSubject } from "../shared/schoolSubjectAdapter"
import { toUISectionedChapter, type ApiCatalogChapter } from "./sectionedChapterAdapter"

/** Loose AI process payload. */
export type ApiSchoolAssessmentProcessResult = {
    subject?: ApiSchoolSubject | null
    chapters?: ApiCatalogChapter[] | null
    exam_date?: string | null
    key_requirements?: string[] | null
}

export function toUISchoolAssessmentPreview(
    raw: ApiSchoolAssessmentProcessResult | null | undefined
): UISchoolAssessmentPreview | null {
    if (raw == null) return null

    const chapters = (raw.chapters ?? [])
        .map((c) => toUISectionedChapter(c))
        .filter((c): c is NonNullable<typeof c> => c != null)

    return {
        subject: raw.subject ? toUISubject(raw.subject) : null,
        chapters,
        date: raw.exam_date ?? null,
        keyRequirements: raw.key_requirements ?? undefined,
    }
}
